
import { Game } from "./app/game";
import UIManager from "./app/UIManager";
import Preload from './app/Preload';

import { GameConfig, Utils } from "./app/Utils";
import { GameZopSDK } from "./app/libs/GameZopSDK";
import Boot from "./app/Boot";


type scaleMode = "FIT" | "SMOOTH";

export enum PHONE_TYPE { LOW = 0, MEDIUM = 1, HIGH = 2, PAD = 3, OUT = 4 }

declare global {
  interface Window { constants: any; }
}

export default class App {

  public static MAX_WIDTH: number = 540;
  public static MAX_HEIGHT: number = 1160;

  public static DEFAULT_WIDTH: number = 800;
  public static DEFAULT_HEIGHT: number = 600;

  public static MAX_WIDTH_HALF: number = App.MAX_WIDTH / 2;
  public static MAX_HEIGHT_HALF: number = App.MAX_HEIGHT / 2;

  public static APP_WIDTH: number = 540;
  public static APP_HEIGHT: number = 1160;

  public static SCALE_MODE: scaleMode = "SMOOTH";

  public app: App;
  public uiManager: UIManager;

  public static _instance: App;
  public static _game: Phaser.Game;
  public static game: Phaser.Scene;

  public static colliderData: any;
  public static levelData: any;
  public static mapData: any;

  public static isLevelup: boolean = false;


  public static totalLives: number = 3;

  public static MUTE: boolean = false;

  public static aspectRatio: number = 0;

  public static PHONETYPE: PHONE_TYPE;

  public static loadingScreen: any;

  public static gamePackage: any;
  public static gameSound: any = true;

  public static gameWidth: any;
  public static gameHeight: any;

  public static gamezopSDK: GameZopSDK;

  public static gameManager: Game;

  constructor() {
    this.processParams();
    App._instance = this;
    //App._game = new Phaser.Game(config);
    this.checkPhoneType();
  }

  private checkPhoneType() {
    App.aspectRatio = window.screen.height / window.screen.width

    if (App.aspectRatio > 1.5 && App.aspectRatio < 1.7) {
      // window.alert("Phone Low");
      App.PHONETYPE = PHONE_TYPE.LOW;
    } else if (App.aspectRatio > 1.7 && App.aspectRatio < 2) {
      // window.alert("Phone Medium");
      App.PHONETYPE = PHONE_TYPE.MEDIUM;
    } else if (App.aspectRatio >= 2) {
      // window.alert("Phone High");
      App.PHONETYPE = PHONE_TYPE.HIGH;
    } else if (App.aspectRatio < 1.5) {
      App.PHONETYPE = PHONE_TYPE.PAD;
      // window.alert("Pad")
    } else {
      App.PHONETYPE = PHONE_TYPE.OUT;
      // window.alert("Out of scope")
    }
  }

  public static GetParam(key: string) {
    if (key in App._instance.params) {
      return App._instance.params[key];
    }

    return null;
  }

  public static vibrate(duration: number) {
    if (window.navigator.vibrate) {
      window.navigator.vibrate(duration);
    }
  }

  private params = {};

  private processParams() {
    this.params = {};
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      this.params[pair[0]] = decodeURIComponent(pair[1]);
    }
  }

  public static ViewportToAppView(viewportPoint: Point): Point {
    return new Point(
      Utils.Interpolate(viewportPoint.x, 0, 1, 0, App.APP_WIDTH),
      Utils.Interpolate(viewportPoint.y, 0, 1, 0, App.APP_HEIGHT)
    );
  }
}

const config = {
  type: Phaser.AUTO,
  backgroundColor: "#000000",
  scale: {
    parent: "phaser-game",
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: '100%',
    height: '100%',
    // width: 560,
    // height: 1260,
  },
  physics: {
    default: "matter",
    matter: {
      gravity: {
        x: 0,
        y: 0
      }
      ,
      debug: false

    },
    fps: 60
  },

  scene: [Boot, Preload, Game, UIManager]
};

/*window.addEventListener('load', () => {
    const app = new App();
})*/
const app = new App();

function initGame() {
  App.gamezopSDK = new GameZopSDK();
}

window.addEventListener("load", () => {
  const game = new Phaser.Game(config);
  window.game = game;
  initGame();
  const resize = () => {
    App.gameWidth = game.config.width;
    App.gameHeight = game.config.height;

    var canvas = game.canvas;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var windowRatio = windowWidth / windowHeight;
    var gameRatio = App.gameWidth / App.gameHeight;

    if (windowRatio < gameRatio) {
      // Scale the game canvas to fit the window width
      var newWidth = windowWidth;
      var newHeight = newWidth / gameRatio;
    } else {
      // Scale the game canvas to fit the window height
      var newHeight = windowHeight;
      var newWidth = newHeight * gameRatio;
    }

    // Set the new canvas size and center it
    canvas.style.width = newWidth + 'px';
    canvas.style.height = newHeight + 'px';
    canvas.style.marginLeft = (windowWidth - newWidth) / 2 + 'px';
    canvas.style.marginTop = (windowHeight - newHeight) / 2 + 'px';

    var isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)
    if (isMobile != null) {
      if (window.screen.width < window.screen.height) {
        document.getElementById("wrongRotation").style.display = "none";
      } else {
        document.getElementById("wrongRotation").style.display = "block";
      }
    }
  };

  window.addEventListener("resize", event => {
    resize();
  });

  resize();
});

export class Point {
  public x: number;
  public y: number;

  constructor(x: number = 0, y: number = 0) {
    this.x = x;
    this.y = y;
  }
};
